import React from 'react';

const CGV = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'left' }}>
      <h1 style={{ textAlign: 'center' }}>Conditions Générales de Vente</h1>
      <p>Bienvenue sur notre site. En passant commande sur notre site, vous acceptez les présentes conditions générales de vente.</p>
      <h2 style={{ textAlign: 'center' }}>1. Objet</h2>
      <p>Les présentes CGV ont pour objet de définir les droits et obligations des parties dans le cadre de la vente en ligne de produits sur notre site.</p>
      <h2 style={{ textAlign: 'center' }}>2. Prix</h2>
      <p>Les prix de nos produits sont indiqués en euros toutes taxes comprises. Nous nous réservons le droit de modifier nos prix à tout moment.</p>
      <h2 style={{ textAlign: 'center' }}>3. Commande</h2>
      <p>Vous pouvez passer commande directement sur notre site en suivant les instructions. Toute commande constitue une acceptation des prix et de la description des produits disponibles à la vente.</p>
      <h2 style={{ textAlign: 'center' }}>4. Livraison</h2>
      <p>Les produits commandés sont livrés à l'adresse que vous avez indiquée lors de la commande. Les délais de livraison sont indiqués lors de la commande.</p>
      <h2 style={{ textAlign: 'center' }}>5. Rétractation</h2>
      <p>Conformément à la législation en vigueur, vous disposez d'un délai de 14 jours pour exercer votre droit de rétractation sans avoir à justifier de motifs ni à payer de pénalités.</p>
      <h2 style={{ textAlign: 'center' }}>6. Responsabilité</h2>
      <p>Notre responsabilité ne pourra être engagée en cas de non-respect des présentes CGV qui serait imputable à un cas de force majeure.</p>
      <h2 style={{ textAlign: 'center' }}>7. Protection des données</h2>
      <p>Nous nous engageons à protéger vos données personnelles conformément à notre politique de confidentialité.</p>
      <h2 style={{ textAlign: 'center' }}>8. Litiges</h2>
      <p>Tout litige relatif à l'interprétation ou à l'exécution des présentes CGV sera soumis à la loi française.</p>
    </div>
  );
};

export default CGV;
